import { message } from 'antd';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  QUERY_PARAM_KEYS,
  QUERY_PARAM_VALUES,
} from '../../../constants/massOfferings/queryParamKeys';
import selectors from '../../../store/selectors';
import { MASS_OFFERINGS_PAYMENT_TYPES } from '../../AddMassOffering/constants';
import { DevotionOfferingsForm } from '../DevotionOfferingsForm/DevotionOfferingsForm';
import { devotionOfferingsFormNames } from '../DevotionOfferingsForm/devotionOfferingsFormOfferingsFormNames';
import { useSubmitMassOffering } from '../../../api/actions/useSubmitMassOffering';

export const formatValues = (values, isServiceFeeEnabled) => {
  return {
    donator_name: values[devotionOfferingsFormNames.fullName],
    donator_email: values[devotionOfferingsFormNames.email],
    donator_phone: values[devotionOfferingsFormNames.phone],
    offering_type_dictionary: values[devotionOfferingsFormNames.offeringType],
    offering_content: values[devotionOfferingsFormNames.offeringContent],
    offering_amount: values[devotionOfferingsFormNames.totalAmountToPay],
    ...(isServiceFeeEnabled && {
      service_fee_covered: values[devotionOfferingsFormNames.userCoversServiceFee],
    }),
    ...(values[devotionOfferingsFormNames.showAddress] && {
      offering_delivery_address: {
        country: values[devotionOfferingsFormNames.country],
        city: values[devotionOfferingsFormNames.city],
        zip_code: values[devotionOfferingsFormNames.zipCode],
        street: values[devotionOfferingsFormNames.street],
      },
    }),
    mass_id: values[devotionOfferingsFormNames.devotionId],
  };
};

const navigateToFreeTransactionConfirmation = pathname => {
  const searchParams = new URLSearchParams({
    [QUERY_PARAM_KEYS.source]: QUERY_PARAM_VALUES.TRANSACTION,
    [QUERY_PARAM_KEYS.sourceType]: QUERY_PARAM_VALUES.SOURCE_INTERNAL,
    [QUERY_PARAM_KEYS.state]: QUERY_PARAM_VALUES.SUCCESS,
  });
  navigate(`${pathname}?${searchParams.toString()}`);
};

const navigateToPayLaterTransactionConfirmation = pathname => {
  const searchParams = new URLSearchParams({
    [QUERY_PARAM_KEYS.source]: QUERY_PARAM_VALUES.TRANSACTION,
    [QUERY_PARAM_KEYS.sourceType]: QUERY_PARAM_VALUES.SOURCE_INTERNAL,
    [QUERY_PARAM_KEYS.state]: QUERY_PARAM_VALUES.SUCCESS,
    [QUERY_PARAM_KEYS.paymentType]: QUERY_PARAM_VALUES.LATER,
  });
  navigate(`${pathname}?${searchParams.toString()}`);
};

export const AddDevotionOffering = ({ devotionsDictionary, inboxDictionary }) => {
  const isServiceFeeEnabled = useSelector(selectors.selectIsServiceFeeEnabled);
  const { loading, mutate } = useSubmitMassOffering();

  const accountId = useSelector(selectors.getAccountId);

  const onSubmit = async values => {
    const { error, payload } = await mutate({
      accountId,
      formValues: formatValues(values, isServiceFeeEnabled),
    });

    if (error) {
      message.error('Wystąpił problem połączenia. Odśwież stronę i spróbuj ponownie', 8);
    } else {
      // eslint-disable-next-line no-restricted-globals
      location.href = payload.tpayLink;
    }

    if (error) {
      message.error('Wystąpił problem połączenia. Odśwież stronę i spróbuj ponownie', 8);
      return;
    }

    if (payload.tpayLink) {
      // eslint-disable-next-line no-restricted-globals
      location.href = payload.tpayLink;
    } else if (payload.paymentType === MASS_OFFERINGS_PAYMENT_TYPES.toBeChosen) {
      // eslint-disable-next-line no-restricted-globals
      navigateToPayLaterTransactionConfirmation(location.pathname);
    } else {
      // eslint-disable-next-line no-restricted-globals
      navigateToFreeTransactionConfirmation(location.pathname);
    }
  };

  return (
    <DevotionOfferingsForm
      onSubmit={onSubmit}
      loading={loading}
      devotionsDictionary={devotionsDictionary}
      inboxDictionary={inboxDictionary}
    />
  );
};

AddDevotionOffering.propTypes = {
  devotionsDictionary: PropTypes.array.isRequired,
  inboxDictionary: PropTypes.array.isRequired,
};
